// features/recentBookings/recentBookingsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAllBookings } from "../services/api";

export const fetchRecentBookings = createAsyncThunk(
  "recentBookings/fetchRecentBookings", 
  async () => {
    const res = await getAllBookings();
    // Get only the first 3 bookings from the response
    const allBookings = res.data.booking || [];
    // const recentBookings = allBookings.slice(0, 3);

    const recentBookings = allBookings
      .filter(booking => !booking.isCancelled) // Exclude cancelled bookings
      .slice(0, 3);
    
    // Process the bookings to extract the needed data
    return recentBookings.map((booking) => ({
      _id: booking._id,
      // User information
      userName: booking.randomUser 
        ? booking.randomUser.name 
        : `${booking.bookedBy?.firstName || ''} ${booking.bookedBy?.lastName || ''}`.trim(),
      userType: booking.randomUser ? 'random' : 'app',
      
      // Sport and pitch information
      sport: booking.slot?.sport?.name || booking.activityId?.selectedSport || 'N/A',
      pitch: booking.slot?.pitch?.name || booking.activityId?.pitchDetail || 'N/A',
      facility: booking.slot?.facility?.name || booking.activityId?.facilityName || 'N/A',
      
      // Date and time information
      date: booking.activityId?.selectedDate || booking.date,
      startTime: booking.activityId?.startTime || booking.timeSlot?.from,
      endTime: booking.activityId?.endTime || booking.timeSlot?.to,
      
      // Price information
      price: booking.activityId?.price || booking.timeSlot?.price || 'N/A',
      
      // Status
      status: 'Confirmed',
      
      // Original booking data for reference
      originalBooking: booking
    }));
  }
);

const recentBookingsSlice = createSlice({
  name: "recentBookings",
  initialState: {
    recentBookings: [],
    status: "idle",
    error: null,
  },
  reducers: {
    clearRecentBookings: (state) => {
      state.recentBookings = [];
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecentBookings.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchRecentBookings.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.recentBookings = action.payload;
        state.error = null;
        console.log("Recent bookings data:", state.recentBookings);
      })
      .addCase(fetchRecentBookings.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        console.error("Failed to fetch recent bookings:", action.error);
      });
  },
});

export const { clearRecentBookings } = recentBookingsSlice.actions;

// Selectors
export const selectRecentBookings = (state) => state.recentBookings?.recentBookings || [];
export const selectRecentBookingsStatus = (state) => state.recentBookings?.status || "idle";
export const selectRecentBookingsError = (state) => state.recentBookings?.error || null;

export default recentBookingsSlice.reducer; 